<template>
  <BaseModal
    :heading="
      $t('global.actions.email_item', { item: $t('global.items.invoice') })
    "
    :parentRoute="{
      name: parentRouteName
    }"
    small
    useForm
    @submit="send"
    :loading="$apollo.loading"
  >
    <Form
      v-model:emailAddress="emailAddress"
      v-model:emailSubject="emailSubject"
      v-model:editorContent="editorContent"
    />
    <template #footer>
      <BaseButton
        :loading="isSaving"
        submitForm
        v-test="'invoice-email-save'"
      >
        {{ $t('global.actions.send') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import useVuelidate from '@vuelidate/core';
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import { flash } from '@/helpers/ui';
import { UploadedImageUsage } from '@/types';
import Form from './Form.vue';

export default defineComponent({
  components: {
    Form,
  },
  props: {
    parentRouteName: {
      type: String,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate(), UploadedImageUsage };
  },
  data() {
    return {
      emailAddress: '',
      emailSubject: '',
      editorContent: '',
      isSaving: false,
    };
  },
  apollo: {
    order: {
      query: gql`
        query getOrder($id: ID!) {
          order(id: $id) {
            id
            invoiceEmailSubjectTemplate
            customer {
              email
            }
          }
        }
      `,
      variables() {
        return {
          id: this.orderId,
        };
      },
      skip() {
        return !this.orderId;
      },
      result({ data: { order } }) {
        this.emailAddress = order.customer?.email || '';
        this.emailSubject = order.invoiceEmailSubjectTemplate;
      },
    },
  },
  computed: {
    orderId() {
      return this.$route.params.id;
    },
  },
  methods: {
    send() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.isSaving = true;

      const input = {
        destination: this.emailAddress,
        emailSubject: this.emailSubject,
        message: this.editorContent,
        messageType: 'ORDER_INVOICE',
        orderId: this.orderId,
      };

      this.$apollo
        .mutate({
          mutation: gql`
            mutation createMessage($input: CreateMessageInput!) {
              createMessage(input: $input) {
                errors
              }
            }
          `,
          variables: {
            input,
          },
        })
        .then(() => {
          if (this.parentRouteName === 'customer-sales') {
            this.$router.push({
              name: 'customer-sale',
              params: { id: this.orderId },
            });
          } else {
            this.$router.push({
              name: 'sale',
              params: { id: this.orderId },
            });
          }
          flash(this.$t('global.flash.email_sent'));
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
  },
});
</script>
